export default __webpack_public_path__ + "static/ringType4-368567e412226af0513bbd23f7b829a5.png";